import { setIdReduxAction } from '../../../../redux/actions/set-id'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import WORKOUT_EXERCISES_PATH from '../../constants/path'
import getByIdWorkoutExerciseSelector from '../../selectors/get-by-id'

function updateCurrentWorkoutExerciseAction (id) {
  return (dispatch, getState) => {
    const instance = id
      ? getByIdWorkoutExerciseSelector(id)(getState())
      : null
    dispatch(setIdReduxAction({
      type: instance
        ? WORKOUT_EXERCISES_ACTION.UPDATE_CURRENT
        : WORKOUT_EXERCISES_ACTION.DELETE_CURRENT,
      payload: {
        path: WORKOUT_EXERCISES_PATH.CURRENT,
        instance
      }
    }))
  }
}

export default updateCurrentWorkoutExerciseAction
